import React from 'react';
import CustomModal from './index';
import PropTypes from 'prop-types';

const ModalBase = ({ title, close, children, size = 'lg' }) => (
  <CustomModal title={title} show={true} close={close} size={size}>
    <div className='px-4'>{children(close)}</div>
  </CustomModal>
);

ModalBase.proptypes = {
  title: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default ModalBase;
